import { useState } from "react";
import axios from "axios";
import { CheckCircle2, Loader2 } from "lucide-react";
import { API, errMsg } from "@/lib/api";
import { sendSimulationEmail } from "@/lib/formsubmit";
import { track } from "@/lib/track";

const field = "h-11 w-full rounded-xl border border-slate-200 px-4 text-sm outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20";

export const LeadForm = ({ result }) => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", notes: "" });
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.name.trim().length < 2 || form.phone.replace(/\D/g, "").length < 6) return setError("Inserisci nome e un numero di telefono valido.");
    setError("");
    setState("loading");
    try {
      await axios.post(`${API}/leads`, {
        ...form,
        address: result.address, building_type: result.buildingType,
        consumption_kwh: result.consumptionEstimated ? null : result.consumptionUsed,
        panels: result.panels, kwp: result.kwp, zone: result.zone, feasibility: result.feasibility,
        savings: result.savings, currency: result.currency,
        city: result.city, region: result.region, lat: result.lat, lng: result.lng,
      });
      setState("done");
      track("generate_lead", { method: "form_richiamata" });
      // Copia della richiesta via email a sales@pixasolar.online (il lead è già salvato nel CRM)
      sendSimulationEmail(result, form).catch((err) => console.warn("Email richiesta non inviata:", err.message));
    } catch (err) {
      setError(errMsg(err));
      setState("idle");
    }
  };

  if (state === "done")
    return (
      <div data-testid="lead-capture-success" className="flex items-center gap-4 rounded-3xl bg-white p-6">
        <CheckCircle2 className="h-8 w-8 shrink-0 text-emerald-600" />
        <div>
          <p className="font-display text-lg font-semibold text-slate-900">Richiesta ricevuta, grazie {form.name.split(" ")[0]}!</p>
          <p className="text-sm text-slate-600">Un nostro consulente ti ricontatterà al più presto per il preventivo dettagliato.</p>
        </div>
      </div>
    );

  return (
    <form onSubmit={submit} data-testid="lead-capture-form" className="rounded-3xl bg-white p-6 sm:p-8">
      <h3 className="font-display text-xl font-semibold text-slate-900">Preferisci essere richiamato?</h3>
      <p className="mt-1 text-sm text-slate-600">Lascia nome e telefono: ti inviamo un preventivo dettagliato gratuito.</p>
      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        <input data-testid="lead-capture-name-input" className={field} placeholder="Nome e cognome *" value={form.name} onChange={set("name")} />
        <input data-testid="lead-capture-phone-input" className={field} placeholder="Telefono *" type="tel" value={form.phone} onChange={set("phone")} />
        <input data-testid="lead-capture-email-input" className={field} placeholder="Email (opzionale)" type="email" value={form.email} onChange={set("email")} />
        <input data-testid="lead-capture-notes-input" className={field} placeholder="Orario preferito / note" value={form.notes} onChange={set("notes")} />
      </div>
      {error && <p data-testid="lead-capture-error" className="mt-3 text-sm text-rose-600">{error}</p>}
      <button
        data-testid="lead-capture-submit-button"
        disabled={state === "loading"}
        className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 py-3.5 font-semibold text-white transition-colors hover:bg-emerald-500 hover:text-slate-900 disabled:opacity-70 sm:w-auto sm:px-8"
      >
        {state === "loading" && <Loader2 className="h-4 w-4 animate-spin" />} Richiedi il preventivo
      </button>
      <p className="mt-3 text-xs text-slate-400">Inviando accetti di essere ricontattato da Apollo Solar per questa richiesta.</p>
    </form>
  );
};
